import Head from "next/head";
import CookieBanner from "@/components/CookieBanner";
import Footer from "@/components/common/Footer";
import Header from "@/components/common/Header";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

export default function AffiliatePartnerWerden() {
  return (
    <>
      <Head>
        <title>FotoboxGuru – Partner werden</title>
        <meta name="description" content="FotoboxGuru – Partner werden" />
        <meta name="keywords" content="FotoboxGuru – Partner werden" />
        <meta name="robots" content="noindex, nofollow" />
        <link rel="icon" href="/fav/favicon.ico" type="image/x-icon" />
      </Head>
      <div className="bg-[#F9F9F9]">
        <div>
          <Header />

          <main className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8 lg:py-16">
            <section className="rounded-3xl bg-white p-6 shadow-[0_24px_70px_-48px_rgba(15,23,42,0.35)] ring-1 ring-slate-200 sm:p-8 lg:p-10">
              <div className="inline-flex items-center rounded-full bg-[#FFF1EE] px-3 py-1 text-xs font-semibold text-[#FF5744]">
                Partnerprogramm
              </div>
              <h1 className="mt-4 text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
                Werde FotoboxGuru Affiliate-Partner und verdiene mit
              </h1>
              <p className="mt-4 max-w-3xl text-lg leading-8 text-slate-700">
                Du hast eine Community oder betreibst eine Webseite im Event-
                oder Hochzeitsbereich? Dann ist unser Affiliate-Programm genau
                das Richtige für dich.
              </p>

              <div className="mt-6 flex flex-wrap items-center gap-3">
                <a
                  href="mailto:partner@fotoboxguru.de?subject=Affiliate%20Partnerschaft&body=Name:%0AWebseite:%0AInstagram%20Profil%20(optional):%0ATikTok%20Profil%20(optional):%0AZielgruppe/Branche:%0AWarum%20möchtest%20du%20Partner%20werden?:%0A"
                  className="inline-flex items-center justify-center rounded-full bg-[#FF5744] px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-[#eb4836] hover:shadow-md"
                >
                  Jetzt Partner werden
                </a>
                <span className="text-sm text-slate-600">
                  Schnell und unkompliziert per E-Mail an{" "}
                  <a
                    href="mailto:partner@fotoboxguru.de"
                    className="font-semibold text-slate-900 underline hover:no-underline"
                  >
                    partner@fotoboxguru.de
                  </a>
                </span>
              </div>
            </section>

            <section className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-2">
              <div className="rounded-2xl bg-white p-6 ring-1 ring-slate-200 shadow-[0_14px_40px_-28px_rgba(15,23,42,0.35)] sm:p-8">
                <h2 className="text-2xl font-semibold tracking-tight text-slate-900">
                  So funktioniert’s
                </h2>
                <ol className="mt-5 space-y-4 text-slate-700">
                  <li className="flex gap-3">
                    <span className="mt-0.5">1️⃣</span>
                    <span>
                      <a
                        href="mailto:partner@fotoboxguru.de?subject=Affiliate%20Partnerschaft&body=Name:%0AWebseite:%0AInstagram%20Profil%20(optional):%0ATikTok%20Profil%20(optional):%0AZielgruppe/Branche:%0AWarum%20möchtest%20du%20Partner%20werden?:%0A"
                        className="font-semibold text-[#FF5744] underline hover:no-underline"
                      >
                        Schreibe uns eine E-Mail
                      </a>{" "}
                      mit ein paar Infos zu dir.
                    </span>
                  </li>
                  <li className="flex gap-3">
                    <span className="mt-0.5">2️⃣</span>
                    <span>
                      Du erhältst deinen individuellen Affiliate-Link und kannst
                      ihn auf deiner Webseite, Social Media oder per E-Mail
                      teilen.
                    </span>
                  </li>
                  <li className="flex gap-3">
                    <span className="mt-0.5">3️⃣</span>
                    <span>
                      Für jede Buchung über deinen Link erhältst du eine
                      attraktive Provision.
                    </span>
                  </li>
                </ol>
              </div>

              <div className="rounded-2xl bg-white p-6 ring-1 ring-slate-200 shadow-[0_14px_40px_-28px_rgba(15,23,42,0.35)] sm:p-8">
                <h2 className="text-2xl font-semibold tracking-tight text-slate-900">
                  Unsere Produkte – deine Verdienstmöglichkeiten
                </h2>

                <div className="mt-5 space-y-5 text-slate-700">
                  <div>
                    <h3 className="font-semibold text-slate-900">
                      🎉 Fotobox-Vermittlung
                    </h3>
                    <p className="mt-1">
                      Wir vergleichen die besten Fotobox-Anbieter und vermitteln
                      Fotoboxen für Events – perfekt für Hochzeiten, Geburtstage
                      und Firmenfeiern.
                    </p>
                    <a
                      href="/"
                      className="mt-2 inline-flex text-sm font-semibold text-[#FF5744] underline hover:no-underline"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Zum Fotobox Vergleich
                    </a>
                  </div>

                  <div>
                    <h3 className="font-semibold text-slate-900">
                      📸 Polaroid-Sofortbildkamera-Vermietung
                    </h3>
                    <p className="mt-1">
                      Ideal für nostalgische Momente und authentische
                      Erinnerungen – eine starke Ergänzung für jedes Event.
                    </p>
                    <a
                      href="/polaroid-kamera-mieten"
                      className="mt-2 inline-flex text-sm font-semibold text-[#FF5744] underline hover:no-underline"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Zur Polaroid Sofortbildkamera Vermietung
                    </a>
                  </div>
                </div>
              </div>
            </section>

            <section className="mt-6 rounded-2xl bg-white p-6 ring-1 ring-slate-200 shadow-[0_14px_40px_-28px_rgba(15,23,42,0.35)] sm:p-8">
              <h2 className="text-2xl font-semibold tracking-tight text-slate-900">
                Warum mitmachen?
              </h2>
              <ul className="mt-4 grid grid-cols-1 gap-3 text-slate-700 sm:grid-cols-2">
                <li>✔️ Einfache Anmeldung & sofort loslegen</li>
                <li>✔️ Attraktive Provisionen für dich</li>
                <li>✔️ Top-Produkte, die Menschen lieben</li>
                <li>✔️ Kein Risiko, nur Chancen</li>
              </ul>
            </section>

            <section className="mt-6 rounded-2xl bg-slate-900 p-6 text-white sm:p-8">
              <h2 className="text-2xl font-semibold tracking-tight">
                Melde dich jetzt und werde Teil unseres Partnerprogramms
              </h2>
              <div className="mt-4">
                <a
                  href="mailto:partner@fotoboxguru.de?subject=Affiliate%20Partnerschaft&body=Name:%0AWebseite:%0AInstagram%20Profil%20(optional):%0ATikTok%20Profil%20(optional):%0AZielgruppe/Branche:%0AWarum%20möchtest%20du%20Partner%20werden?:%0A"
                  className="inline-flex items-center justify-center rounded-full bg-white px-5 py-2.5 text-sm font-semibold text-slate-900 shadow-sm transition hover:shadow-md"
                >
                  ✉️ partner@fotoboxguru.de
                </a>
              </div>
            </section>
          </main>

          <Footer />
        </div>
      </div>
      <CookieBanner />
    </>
  );
}

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}
